import { OFFER_COMPARISON_RESTORE_STATE, OFFER_COMPARISON_TOGGLE_ENABLED, OFFER_COMPARISON_ADD_SELECTION, OFFER_COMPARISON_REMOVE_SELECTION, OFFER_COMPARISON_REPLACE_SELECTION, OFFER_COMPARISON_CLEAR_ALL } from './actionConstants'
import type { AppAction } from './types/ActionTypes'

export function restoreOfferComparisonState(restoredState: App.OfferComparisonState): AppAction {
  return {
    type: OFFER_COMPARISON_RESTORE_STATE,
    restoredState,
  }
}

export function toggleOfferComparisonEnabled(): AppAction {
  return {
    type: OFFER_COMPARISON_TOGGLE_ENABLED,
  }
}

export function addOfferComparisonSelection(selection: App.OfferComparisonSelection): AppAction {
  return {
    type: OFFER_COMPARISON_ADD_SELECTION,
    selection,
  }
}

export function removeOfferComparisonSelection(selectionId: string): AppAction {
  return {
    type: OFFER_COMPARISON_REMOVE_SELECTION,
    selectionId,
  }
}

export function replaceOfferComparisonSelection(selection: App.OfferComparisonSelection): AppAction {
  return {
    type: OFFER_COMPARISON_REPLACE_SELECTION,
    selection,
  }
}

export function clearAllOfferComparisonSelections(): AppAction {
  return {
    type: OFFER_COMPARISON_CLEAR_ALL,
  }
}
